import {
  handleAddToCart,
  handleClearCart,
  handleDecrementCart,
  handleRemoveFromCart,
} from "./session.cart";

export async function dispatchSessionAction({
  action,
  send,
  setScreen,
  cart,
  setCart,
  setMessages,
  productIndexRef,
}) {
  if (!action) return;

  if (action.type === "send") {
    await send(action.message);
    return { ok: true };
  }

  if (action.type === "add_to_cart") {
    return handleAddToCart({
      action,
      productIndexRef,
      setCart,
      setMessages,
    });
  }

  if (action.type === "decrement_cart") {
    return handleDecrementCart({
      action,
      cart,
      setCart,
      setMessages,
    });
  }

  if (action.type === "remove_from_cart") {
    return handleRemoveFromCart({
      action,
      cart,
      setCart,
      setMessages,
    });
  }

  if (action.type === "clear_cart") {
    return handleClearCart({
      setCart,
      setMessages,
    });
  }

  if (action.type === "go_to_checkout") {
    setScreen("checkout");
    return { ok: true };
  }

  setMessages((m) => [
    ...m,
    {
      role: "assistant",
      text: `ℹ️ Дія ще не реалізована: ${action.type}`,
    },
  ]);

  return { ok: false, reason: "not_implemented" };
}